import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const EqualsignIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path fillRule="evenodd" d="M4.52002 15.75H19.48V13.91H4.52002V15.75ZM4.52002 10.09H19.48V8.25H4.52002V10.09Z" />
    </SvgIcon>
  );
});
